import { render, staticRenderFns } from "./ChatAudioMessage.vue?vue&type=template&id=7e31b969&scoped=true&lang=pug"
import script from "./ChatAudioMessage.vue?vue&type=script&lang=js"
export * from "./ChatAudioMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatAudioMessage.vue?vue&type=style&index=0&id=7e31b969&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e31b969",
  null
  
)

export default component.exports